//----------------------------------------
//------ JAVASCRIPT HOOK FUNCTIONS -------
//----------------------------------------
c7 = {
    hooks: { action: {}, filter: {} },
    addAction: function (action, callable, priority, tag) {
        c7.addHook("action", action, callable, priority, tag);
    },
    addFilter: function (action, callable, priority, tag) {
        c7.addHook("filter", action, callable, priority, tag);
    },
    doAction: function (action) {
        c7.doHook("action", action, arguments);
    },
    applyFilters: function (action) {
        return c7.doHook("filter", action, arguments);
    },
    removeAction: function (action, tag) {
        c7.removeHook("action", action, tag);
    },
    removeFilter: function (action, priority, tag) {
        c7.removeHook("filter", action, priority, tag);
    },
    addHook: function (hookType, action, callable, priority, tag) {
        if (undefined == c7.hooks[hookType][action]) {
            c7.hooks[hookType][action] = [];
        }
        var hooks = c7.hooks[hookType][action];
        if (undefined == tag) {
            tag = action + "_" + hooks.length;
        }
        if (priority == undefined) {
            priority = 10;
        }

        c7.hooks[hookType][action].push({
            tag: tag,
            callable: callable,
            priority: priority,
        });
    },
    doHook: function (hookType, action, args) {
        // splice args from object into array and remove first index which is the hook name
        args = Array.prototype.slice.call(args, 1);

        if (undefined != c7.hooks[hookType][action]) {
            var hooks = c7.hooks[hookType][action],
                hook;
            //sort by priority
            hooks.sort(function (a, b) {
                return a["priority"] - b["priority"];
            });
            for (var i = 0; i < hooks.length; i++) {
                hook = hooks[i].callable;
                if (typeof hook != "function") hook = window[hook];
                if ("action" == hookType) {
                    hook.apply(null, args);
                } else {
                    args[0] = hook.apply(null, args);
                }
            }
        }
        if ("filter" == hookType) {
            return args[0];
        }
    },
    removeHook: function (hookType, action, priority, tag) {
        if (undefined != c7.hooks[hookType][action]) {
            var hooks = c7.hooks[hookType][action];
            for (var i = hooks.length - 1; i >= 0; i--) {
                if (
                    (undefined == tag || tag == hooks[i].tag) &&
                    (undefined == priority || priority == hooks[i].priority)
                ) {
                    hooks.splice(i, 1);
                }
            }
        }
    },
};

/**
 * Detect if products are all rendered per collection.
 */
const detectCollectionRender = () => {
    const targetNodes = document.querySelectorAll(
        ".c7-product-collection"
    );

    if (!targetNodes.length) {
        return;
    }
    targetNodes.forEach((target) => {
        new MutationObserver((mutations, observer) => {
            if (document.querySelector(".c7-product-collection__products")) {
                observer.disconnect();
                c7.doAction("c7_collection_products_rendered", target);
                // checkFooter();
            }
        }).observe(target, { childList: true, subtree: true });
    });
};

const detectAddToCartRender = () => {
    const targetNodes = document.querySelectorAll(
        ".c7-buy-product"
    );

    if (!targetNodes.length) {
        return;
    }
    targetNodes.forEach((c7Element) => {
        // new MutationObserver((mutations, observer) => {
        //     if (document.querySelector(".c7-product__add-to-cart")) {
        //         observer.disconnect();
        //         c7.doAction("c7_add_to_cart_rendered", target);
        //         // checkFooter();
        //     }
        // }).observe(target, { childList: true, subtree: true });
        var observer = new MutationObserver(function (mutationsList) {
            for (var mutation of mutationsList) {
                if (mutation.target === c7Element && mutation.type === 'childList') {
                    if (c7Element.querySelectorAll('.c7-product__add-to-cart__price').length > 0) {
                        c7.doAction("c7_add_to_cart_rendered", c7Element);
                        observer.disconnect();
                    }
                }
            }
        });
        observer.observe(c7Element, { childList: true });
    });
};

const detectAddToCartDetailPageRender = () => {
    const target = document.getElementById("c7-content");

    if (target) {
        new MutationObserver((_, observer) => {
            if (document.querySelector(".c7-product__add-to-cart__price")) {
                observer.disconnect();
                c7.doAction("c7_add_to_cart_detail_page_rendered", target);
            }
            // checkFooter();
        }).observe(target, { childList: true, subtree: true });
    }
};

const detectPersonalization = () => {
    const targetNodes = document.querySelectorAll(
        ".c7-personalization"
    );

    if (!targetNodes.length) {
        return;
    }
    targetNodes.forEach((target) => {
        new MutationObserver((mutations, observer) => {
            if (document.querySelector(".c7-product-collection__products")) {
                observer.disconnect();
                c7.doAction("c7_personalization_rendered", target);
                // checkFooter();
            }
        }).observe(target, { childList: true, subtree: true });
    });
}

/**
 * Detect if product detail content is rendered.
 */
const detectProductDetailVideoRender = () => {
    const target = document.getElementById("c7-content");
    if (target) {
        new MutationObserver((_, observer) => {
            if (document.querySelector(".product-detail-page")) {
                observer.disconnect();
                c7.doAction("c7_product_detail_rendered", target);
                // checkFooter();
            }
            // checkFooter();
        }).observe(target, { childList: true, subtree: true });
    }
};

// const checkFooter = () => {
// 	const windowHeight = jQuery(window).height();
// 	const contentHeight = jQuery("body").height();
// 	const footerHeight = jQuery("footer").height();
// 	console.log(windowHeight);
// 	console.log(contentHeight);
// 	if (jQuery("footer").hasClass("sticky")) {
// 		if (windowHeight < contentHeight + footerHeight) {
// 			jQuery("footer").removeClass("sticky");
// 		}
// 	} else {
// 		if (windowHeight > contentHeight) {
// 			jQuery("footer").addClass("sticky");
// 		}
// 	}
// };

const checkInstagram = () => {
    /* SEO */
    const target = document.getElementById("sb_instagram");

    if (target) {
        new MutationObserver((_, observer) => {
            if (document.querySelector(".sbi_hover_caption_wrap")) {
                observer.disconnect();
                jQuery('.sbi_hover_caption_wrap, .sbi_caption').attr('role', 'heading');
                jQuery('.sbi_imgLiquid_bgSize').attr('aria-label', 'https://www.instagram.com');
            }
            // checkFooter();
        }).observe(target, { childList: true, subtree: true });
    }
}

const detectCartCarrots = () => {
    /* SEO */
    const target = document.getElementById("c7-cart");

    if (target) {
        new MutationObserver((_, observer) => {
            if (document.querySelector(".c7-carrot")) {
                observer.disconnect();
                c7.doAction("c7_cart_carrots_rendered", target);
            }
            // checkFooter();
        }).observe(target, { childList: true, subtree: true });
    }
}

const detectSideCartRender = () => {
    const target = document.querySelector('body');
    if (target) {
        new MutationObserver((_, observer) => {
            if (document.querySelector("#c7-side-cart")) {
                observer.disconnect();
                c7.doAction("c7_side_cart_rendered", target);
            }
        }).observe(target, { childList: true, subtree: true });
    }
};

(function () {
    detectCollectionRender();
    detectProductDetailVideoRender();
    detectAddToCartRender();
    detectPersonalization();
    checkInstagram();
    detectCartCarrots();
    detectSideCartRender();
    detectAddToCartDetailPageRender();
})();
